/**
 * Interfaccia DataTablesSchema
 * Tale struttura dati rappresenta lo schema adottato da DataTables (https://datatables.net/) ed utilizzato in tutte le tabelle del frontend FPNet.
 * È sostanzialmente un oggetto container in cui la proprietà data è un array di oggetti da rappresentare in una tabella.
 * Nell'edizione "typescript", tale interfaccia è un generic, dove T rappresenta il tipo di array contenuto in data.
 */
import {AziendaRecord} from "./AziendaRecord";
import {ElementoRMLRecord} from "./ElementoRMLRecord";
import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {AziendaBase} from "./AziendaNavRecord";
import {QualificaRecord, TabellaElementiRMLRecord} from "./CentroDiCostoRecord";
import {ElementoRMLXTabellaRecord} from "./ElementoRMLXTabellaRecord";
import {LavoratoreRecord} from "@commons/mapping/LavoratoreRecord";
import {LavoratoreRML} from "./LavoratoreRML";
import {CCNLLivelloRecord, CCNLRecord} from "./SettoriCCNL";
import {SpoolRecord} from "./SpoolRecord";

export interface DataTablesSchema<T> {
    data: T[],
    recordsFiltered: number, // numero di elementi filtrati (risultato di una ricerca generica o di un filtro specifico)
    recordsTotal: number, // numero di elementi totali
    URI?: string, // Rappresenta l'uri dell'intera tabella
}

// Per ogni Record viene definito un tipo specifico:
export type Aziende = DataTablesSchema<AziendaRecord>;
export type Lavoratori = DataTablesSchema<LavoratoreRecord>;
export type RetribuzioneLavoratore = DataTablesSchema<LavoratoreRML>;
export type ElementiRML = DataTablesSchema<ElementoRMLRecord>;
export type TabelleElementiRML = DataTablesSchema<TabellaElementiRMLRecord>;
export type ElementiRMLXTabella = DataTablesSchema<ElementoRMLXTabellaRecord>;
export type UnitaLocali = DataTablesSchema<AziendaBase>;
export type Qualifiche = DataTablesSchema<QualificaRecord>;
export type ContrattiCCNL = DataTablesSchema<CCNLRecord>;
export type ContrattiCCNLLivelli = DataTablesSchema<CCNLLivelloRecord>;

interface ISpoolAzienda extends DataTablesSchema<SpoolRecord> {
    spoolSize: number;
}

export type SpoolAzienda = ISpoolAzienda;

// Helper per la determinazione delle chiavi utili alla gestione della cache da parte di RTK Query (vedi prop providesTags)
export function getTagsList<T extends URIAndTrace>(result: DataTablesSchema<T> | undefined, type: string): any[] {
    // is result available?
    return result && result.data
        ? // successful query
        [
            ...result.data.map(({URI}) => ({type, URI} as const)),
            {type, id: 'LIST'},
        ]
        : // an error occurred, but we still want to refetch this query when `{ type: 'Posts', id: 'LIST' }` is invalidated
        [{type, id: 'LIST'}];
}
